.wait {
  color: var(--text-muted);
}

.line {
  margin: 0;
}
